import { FunctionComponent, useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { themes } from './data';
import { ResetCSS, FontFaces, DefaultCSS } from './styles';
import { ContainerProps } from './types';

/**
 * A wrapper component that is necessary for the visual representation.
 */
export const Container: FunctionComponent<ContainerProps> = (props) => {
  // Add or remove tabbing CSS class
  useEffect(() => {
    const handleFirstTab = (e: KeyboardEvent): void => {
      if (e.key === 'Tab') {
        const handleMouseDownOnce = () => {
          document.body.classList.remove('tabbing');
          window.removeEventListener('mousedown', handleMouseDownOnce);
          window.addEventListener('keydown', handleFirstTab);
        };
        document.body.classList.add('tabbing');
        window.removeEventListener('keydown', handleFirstTab);
        window.addEventListener('mousedown', handleMouseDownOnce);
      }
    };
    window.addEventListener('keydown', handleFirstTab);
  }, []);

  return (
    <ThemeProvider theme={themes.light}>
      <ResetCSS />
      <FontFaces />
      <DefaultCSS />
      {props.children}
    </ThemeProvider>
  );
};

export default Container;
